// indicators.ts
export interface Indicator {
  id: string;
  label: string;
  color?: string;
}

export interface IndicatorCategory {
  category: string;
  indicators: Indicator[];
}

export const INDICATORS: IndicatorCategory[] = [
  {
    category: "Moving Averages",
    indicators: [
      { id: "STD;SMA", label: "SMA" },
      { id: "STD;EMA", label: "EMA" },
      { id: "STD;WMA", label: "WMA" },
      { id: "STD;VWMA", label: "VWMA" },
      { id: "STD;Hull%1MA", label: "Hull MA" },
      { id: "STD;DEMA", label: "Double EMA" },
      { id: "STD;TEMA", label: "Triple EMA" },
      { id: "STD;Smoothed%1Moving%1Average", label: "Smoothed MA" },
      { id: "STD;Least%1Squares%1Moving%1Average", label: "Least Squares MA" },
      { id: "STD;Arnaud%1Legoux%1Moving%1Average", label: "Arnaud Legoux MA" },
      {
        id: "STD;Kaufmans_Adaptive_Moving_Average",
        label: "Kaufman's Adaptive MA",
      },
      { id: "STD;McGinley%1Dynamic", label: "McGinley Dynamic" },
      { id: "STD;MA%1Cross", label: "MA Cross" },
      { id: "STD;MA%Ribbon", label: "MA Ribbon" },
    ],
  },
  {
    category: "Trend Systems",
    indicators: [
      { id: "STD;Supertrend", label: "Supertrend" },
      { id: "STD;PSAR", label: "Parabolic SAR" },
      { id: "STD;Ichimoku%1Cloud", label: "Ichimoku Cloud" },
      { id: "STD;Aroon", label: "Aroon" },
      { id: "STD;Aroon_Oscillator", label: "Aroon Oscillator" },
      {
        id: "STD;Average%1Directional%1Index",
        label: "Average Directional Index",
      },
      { id: "STD;DMI", label: "DMI" },
      { id: "STD;Linear_Regression", label: "Linear Regression" },
      { id: "STD;Trend%1Strength%1Index", label: "Trend Strength Index" },
      { id: "STD;Chande%1Kroll%1Stop", label: "Chande Kroll Stop" },
      { id: "STD;Chandelier_Exit", label: "Chandelier Exit" },
    ],
  },
  {
    category: "Oscillators",
    indicators: [
      { id: "STD;RSI", label: "RSI" },
      { id: "STD;MACD", label: "MACD" },
      { id: "STD;CCI", label: "CCI" },
      { id: "STD;Stochastic", label: "Stochastic" },
      { id: "STD;Stochastic_RSI", label: "Stochastic RSI" },
      { id: "STD;SMI", label: "SMI" },
      { id: "STD;SMI_Ergodic_Indicator_Oscillator", label: "SMI Ergodic" },
      { id: "STD;SMI_Ergodic_Oscillator", label: "SMI Ergodic Oscillator" },
      { id: "STD;Awesome_Oscillator", label: "Awesome Oscillator" },
      { id: "STD;Chande_Momentum_Oscillator", label: "Chande Momentum" },
      { id: "STD;Connors_RSI", label: "Connors RSI" },
      { id: "STD;Relative_Vigor_Index", label: "Relative Vigor Index" },
      {
        id: "STD;Relative_Volatility_Index",
        label: "Relative Volatility Index",
      },
      { id: "STD;ROC", label: "ROC" },
      { id: "STD;Momentum", label: "Momentum" },
      { id: "STD;DPO", label: "DPO" },
      { id: "STD;Price_Oscillator", label: "Price Oscillator" },
      { id: "STD;Volume%1Oscillator", label: "Volume Oscillator" },
      { id: "STD;Klinger%1Oscillator", label: "Klinger Oscillator" },
      { id: "STD;Chaikin_Oscillator", label: "Chaikin Oscillator" },
      { id: "STD;Ultimate_Oscillator", label: "Ultimate Oscillator" },
      { id: "STD;Balance%1of%1Power", label: "Balance of Power" },
      { id: "STD;Coppock%1Curve", label: "Coppock Curve" },
      { id: "STD;Know_Sure_Thing", label: "Know Sure Thing" },
      { id: "STD;TRIX", label: "TRIX" },
      { id: "STD;True%1Strength%1Indicator", label: "True Strength Indicator" },
      { id: "STD;Fisher_Transform", label: "Fisher Transform" },
      { id: "STD;Woodies%1CCI", label: "Woodies CCI" },
    ],
  },
  {
    category: "Volatility",
    indicators: [
      { id: "STD;Bollinger_Bands", label: "Bollinger Bands" },
      { id: "STD;Bollinger_Bands_Width", label: "Bollinger Bands Width" },
      { id: "STD;Bollinger_Bands_B", label: "Bollinger Bands %B" },
      { id: "STD;Bollinger%1Bars", label: "Bollinger Bars" },
      { id: "STD;BBTrend", label: "BB Trend" },
      { id: "STD;Keltner_Channels", label: "Keltner Channels" },
      { id: "STD;Donchian_Channels", label: "Donchian Channels" },
      { id: "STD;Average_True_Range", label: "ATR" },
      { id: "STD;Historical_Volatility", label: "Historical Volatility" },
      { id: "STD;Choppiness_Index", label: "Choppiness Index" },
      { id: "STD;Chop%1Zone", label: "Chop Zone" },
      { id: "STD;Ulcer_Index", label: "Ulcer Index" },
      { id: "STD;Mass%1Index", label: "Mass Index" },
    ],
  },
  {
    category: "Volume",
    indicators: [
      { id: "Volume@tv-basicstudies", label: "Volume" },
      { id: "STD;24h%Volume", label: "24h Volume" },
      { id: "STD;On_Balance_Volume", label: "OBV" },
      {
        id: "STD;Accumulation_Distribution",
        label: "Accumulation/Distribution",
      },
      { id: "STD;Chaikin_Money_Flow", label: "Chaikin Money Flow" },
      { id: "STD;Money_Flow", label: "Money Flow" },
      { id: "STD;EOM", label: "Ease of Movement" },
      { id: "STD;EFI", label: "Elder Force Index" },
      { id: "STD;Cumulative%1Volume%1Delta", label: "Cumulative Volume Delta" },
      { id: "STD;Cumulative%1Volume%1Index", label: "Cumulative Volume Index" },
      { id: "STD;Net%1Volume", label: "Net Volume" },
      { id: "STD;Negative_Volume_Index", label: "Negative Volume Index" },
      { id: "STD;Positive_Volume_Index", label: "Positive Volume Index" },
      { id: "STD;UP_DOWN_Volume", label: "Up/Down Volume" },
      {
        id: "STD;Relative%1Volume%1at%1Time",
        label: "Relative Volume at Time",
      },
      { id: "STD;Price_Volume_Trend", label: "Price Volume Trend" },
      {
        id: "PriceVolumeTrend@tv-basicstudies",
        label: "Price Volume Trend (Basic)",
      },
    ],
  },
  {
    category: "Breadth & Market",
    indicators: [
      { id: "STD;Advance%1Decline%1Line", label: "Advance/Decline Line" },
      { id: "STD;Advance%1Decline%1Ratio", label: "Advance/Decline Ratio" },
      {
        id: "STD;Advance_Decline_Ratio_Bars",
        label: "Advance/Decline Ratio Bars",
      },
      { id: "STD;Bull%Bear%Power", label: "Bull Bear Power" },
      { id: "STD;Average%Day%Range", label: "Average Day Range" },
      { id: "STD;Open%Interest", label: "Open Interest" },
      { id: "STD;Performance", label: "Performance" },
      { id: "STD;Technical%1Ratings", label: "Technical Ratings" },
    ],
  },
  {
    category: "Pivots",
    indicators: [
      { id: "STD;Pivot%1Points%1Standard", label: "Pivot Points Standard" },
      { id: "STD;Pivot%1Points%1High%1Low", label: "Pivot Points High Low" },
      {
        id: "BookerIntradayPivots@tv-basicstudies",
        label: "Booker Intraday Pivots",
      },
      {
        id: "BookerMissedPivots@tv-basicstudies",
        label: "Booker Missed Pivots",
      },
      {
        id: "STD;Rob%1Booker%1Ghost%1Pivots%1v2",
        label: "Rob Booker Ghost Pivots",
      },
      {
        id: "BookerKnoxvilleDivergence@tv-basicstudies",
        label: "Booker Knoxville Divergence",
      },
      { id: "BookerReversal@tv-basicstudies", label: "Booker Reversal" },
    ],
  },
  {
    category: "Other",
    indicators: [
      { id: "STD;Correlation_Coeff", label: "Correlation Coefficient" },
      {
        id: "CorrelationCoefficient@tv-basicstudies",
        label: "Correlation Coefficient (Basic)",
      },
      { id: "STD;Divergence%1Indicator", label: "Divergence Indicator" },
      { id: "STD;Seasonality", label: "Seasonality" },
      { id: "STD;RCI_Ribbon", label: "RCI Ribbon" },
      { id: "STD;Rank_Correlation_Index", label: "Rank Correlation Index" },
      {
        id: "STD;Price_Momentum_Oscillator",
        label: "Price Momentum Oscillator",
      },
      { id: "STD;Price%1Target", label: "Price Target" },
      { id: "STD;Prings_Special_K", label: "Pring's Special K" },
      { id: "STD;Median", label: "Median" },
      { id: "STD;ENV", label: "Envelope" },
      { id: "STD;Gaps", label: "Gaps" },
      { id: "STD;Zig_Zag", label: "Zig Zag" },
      { id: "STD;Time%1Weighted%1Average%1Price", label: "TWAP" },
      { id: "STD;Trading%1Sessions", label: "Trading Sessions" },
      { id: "STD;Multi-Time%Period%Charts", label: "Multi-Time Period Charts" },
      { id: "STD;Moon%1Phases", label: "Moon Phases" },
      { id: "MoonPhases@tv-basicstudies", label: "Moon Phases (Basic)" },
    ],
  },
];
